import React, { Fragment, useMemo } from "react";
import { Navigate, Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getPrimaryThemeColor } from "../../utils/getThemeColor";
import customConfig from "../../config";
import "./HeaderStyles.css";

const Nav = ({
  auth: { isAuthenticated, loading },
  tenantLogoUrl,
  tenantInfo,
}) => {
  // Get theme class names and color from tenant info
  const themeClass = useMemo(() => {
    const primary = tenantInfo?.primaryColor || 'dark-blue';
    const secondary = tenantInfo?.secondaryColor || 'lime';
    return `${primary}-theme ${secondary}-theme-secondary`;
  }, [tenantInfo]);
  
  const primaryColor = useMemo(() => getPrimaryThemeColor(tenantInfo), [tenantInfo]);

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }
  return (
    <Fragment>
      <nav className={`top-bar fixed no-bg ${themeClass}`} id="header" style={{ background: primaryColor }}>
        <div className={`mb-0 logo-wrapper ${themeClass}`} style={{ background: primaryColor }}>
          {" "}
          <Link to="/landing" className={`logo-inr-wrap bottom-shadow-1 radius-bottom-16 ${themeClass}`} style={{ background: primaryColor, textDecoration: "none", display: "block" }}>
            {" "}
            <img
              src={tenantLogoUrl}
              alt="Logo"
              className="logo logo-wrapper-inner"
              style={{ height: "100%", filter: "brightness(0) invert(1)" }}
            />
          </Link>
          <div className={`top-bar-right-style-1 bottom-shadow-1 blu-bg ${themeClass}`} style={{ background: primaryColor }}>
            <div className="right-nav" style={{ background: primaryColor }}>
              {/* Profile menu moved to sidebar footer */}
            </div>
          </div>
        </div>
      </nav>
    </Fragment>
  );
};

Nav.propTypes = {
  auth: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
  tenantLogoUrl: state.tenant.tenantInfo.tenantLogoUrl,
  tenantInfo: state.tenant.tenantInfo,
});

export default connect(mapStateToProps)(Nav);
